// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__67naU","content":"LoadingAlert_content__2fLlr"};